export const nearestSixteenth = (numIn: number, roundUp: boolean | null = null): number => {
	const decimalPart = (numIn - Math.trunc(numIn)) * 16;
	let roundedDecimal = 0;

	if (roundUp === null) {
		roundedDecimal = Math.round(decimalPart) / 16;
	} else if (roundUp) {
		roundedDecimal = Math.ceil(decimalPart) / 16;
	} else {
		roundedDecimal = Math.floor(decimalPart) / 16;
	}

	return Number((Math.trunc(numIn) + roundedDecimal).toFixed(4));
};
